import { boolean } from 'yup'
import { safify } from '../utils/safify'

export const includeEmojis = boolean()
  .default(true)
  .meta({
    label: 'Include emojis in the post ⭐🥳',
    description: 'Blaze ensures emojis are added whenever appropriate for better engagement.',
    autoFill: true,
  })
  .transform(safify)
